import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { bambooDictEl } from "@/lib/shop/products/bamboo";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/bamboo")({
  head: () => ({
    ...buildProductHead(bambooDictEl),
    links: alternateLinkList("/shop/bamboo", "el"),
  }),
  component: () => <ProductPage dict={bambooDictEl} />,
});
